import { PreviewToneDto } from '../../dto/previewtone/previewtonedto';
import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface PreviewToneResponse extends APIResponse 
{
    getPreviewToneDto(): PreviewToneDto;
}

export class PreviewToneResponseDtoImpl extends APIResponseDtoImpl implements PreviewToneResponse 
{
    private previewToneResponseDto : PreviewToneDto;

    getPreviewToneDto(): PreviewToneDto
    {
        return this.previewToneResponseDto;
    }
    setPreviewToneDto(previewToneResponseDto: PreviewToneDto)
    {
        this.previewToneResponseDto = previewToneResponseDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/previewtone/previewtoneresponse.tsx